import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Peter Manchester | Front End Developer',
  lang: 'en',
  description: 'Front End Web Developer Portfolio',
};

// HERO DATA
export const heroData = {
  title: 'Hi, I\'m',
  name: 'Peter Manchester',
  subtitle: 'Front End / Javascript Web Developer',
  cta: 'About Me',
  cta2: 'See My Projects'
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'I\'m a Front End Web Developer specialising in JS, HTML, CSS and REACT.',
  paragraphTwo: 'I\'m based just outside of London in the UK.',
  paragraphThree: 'I love Coding and I\'m constantly learning new techniques for Web Development.',
  paragraphFour: 'Whilst I\'m working as a freelance Web Developer I\'m still in search of a great team and a project that I could be a full time member of.',
  resume: 'https://drive.google.com/file/d/1mn-2zN8kF03UMwq0Bh1WTsA-9cCTRuhb/view?usp=sharing', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'Actor Connector - Social Network',
    info: 'A fully functioning Social Network for Theatre makers, made with SASS, React, NodeJS, Express and MongoDB.',
    info2: '',
    url: 'https://actorconnector.herokuapp.com/',
    repo: 'https://github.com/petermanchester1987/actor-connect', 
  },
  {
    id: nanoid(),
    img: 'project2.jpg',
    title: 'Cami Consulting Business Consultancy Website',
    info: 'This is a business website I\'m currently working on using Gatsby, React, Bootstrap and custom CSS.',
    info2: '',
    url: 'https://mystifying-thompson-6c4f2e.netlify.app/',
    repo: 'https://github.com/petermanchester1987/cami_gatsby',
  },
  {
    id: nanoid(),
    img: 'project3.jpg',
    title: 'Landing Site',
    info: 'My Personal Actor Website From When I Used to Act!',
    info2: '',
    url: 'https://www.petermanchester.com/',
    repo: 'https://github.com/petermanchester1987/petermanchesteractorwebsite',
  },
  {
    id: nanoid(),
    img: 'project4.jpg',
    title: 'GitHub API React App',
    info: 'A React app consuming the GitHub API. Type in a name and click on one to see Bio and Repos.',
    info2: '',
    url: 'https://petermanchester-githubprofiles.herokuapp.com/',
    repo: 'https://github.com/petermanchester1987/github-profiles',
  },
  {
    id: nanoid(),
    img: 'project5.jpg',
    title: 'Brochure Website',
    info: 'A simple one page brochure landing site for an Actor. Using HTML, CSS, JS and Materialize.',
    info2: '',
    url: 'https://www.rachelmanchester.co.uk/',
    repo: 'https://github.com/petermanchester1987/rachelmanchesterwebsite',
  },
];

// CONTACT DATA
export const contactData = {
  cta: 'Do You Have A Role That You Think I Might Be Right For?',
  btn: 'Email Me',
  email: 'petermanchester1987@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/PManchester1987',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/peter-manchester-5836361aa/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/petermanchester1987/',
    },
  ],
};


